module.exports = __webpack_public_path__ + "assets/favicon-old-512.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon-old-512.png
// module id = 707
// module chunks = 0